'use client'

import { type ReactNode, useEffect, useState } from 'react'

interface StickyNavClientProps {
  children: ReactNode
}

export const StickyNavClient = ({ children }: StickyNavClientProps) => {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 200)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    handleScroll()
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div
      className="fixed top-0 right-0 left-0 z-40 hidden transition-transform duration-300 lg:block"
      style={{ transform: visible ? 'translateY(0)' : 'translateY(-100%)' }}
    >
      {children}
    </div>
  )
}
